import { RouteRecordRaw } from 'vue-router'

const ranksRoutes: RouteRecordRaw[] = [
  {
    path: '/crew/rank-order',
    name: 'ranks.order',
    component: () => import('@/modules/crewing/views/ranks/RankOrderIndex.vue'),
    meta: {
      pageTitle: 'Rank order',
      breadcrumbs: ['Rank order']
    }
  }
]

export default ranksRoutes
